const SCOPE = 'list-controls';

export const ListControlsTestIds = {
  ADD_BUTTON: `${SCOPE}.add-button`,
  REMOVE_BUTTON: `${SCOPE}.remove-button`,
};
